export const BaseURL = "https://cyber-note-backend.onrender.com"